import { createContext, useContext, useEffect, type ReactNode } from 'react'

const ProjectIdContext = createContext<string | undefined>(undefined)

/**
 * Set a cookie so the GCP load balancer (HTTP_COOKIE session affinity) routes
 * all requests — including WebSocket upgrades — for the same project to the
 * same backend instance. This keeps the in-memory YDoc room co-located with
 * the REST/chat handlers for that project.
 */
function setAffinityCookie(projectId: string | undefined) {
  if (projectId) {
    document.cookie = `PONPON_PROJECT=${projectId}; path=/; SameSite=Lax`
  }
}

export function ProjectIdProvider({ value, children }: { value: string | undefined; children: ReactNode }) {
  useEffect(() => {
    setAffinityCookie(value)
  }, [value])

  return <ProjectIdContext.Provider value={value}>{children}</ProjectIdContext.Provider>
}

export function useOptionalProjectId(): string | undefined {
  return useContext(ProjectIdContext)
}

export function useProjectId(): string {
  const id = useOptionalProjectId()
  if (!id) throw new Error('useProjectId() must be used within a <ProjectIdProvider>')
  return id
}
